import { render, staticRenderFns } from "./Set_price_information.vue?vue&type=template&id=108095ae&scoped=true&"
import script from "./Set_price_information.vue?vue&type=script&lang=js&"
export * from "./Set_price_information.vue?vue&type=script&lang=js&"
import style0 from "./Set_price_information.vue?vue&type=style&index=0&id=108095ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108095ae",
  null
  
)

export default component.exports